import React, { useEffect } from 'react';
import { useCurrency } from '../../../../../hooks/currency';
import { useXSelectable, XSelectablesType } from '../../../../x/selectables/XSelectables';
import { VariantGroupProduct } from '../../../../../XV2';
import { XText, XTextType } from '../../../../x/text/XText';
import { ActiveOrderProduct } from '../../../../../hooks/active-order';
import { useVariantProductPrice } from '../../../../../hooks/useVariantProductPrice';
import './OrderProductVariantProduct.scss';
import { XCard } from '@orderx/lab/ui';

type Props = {
    orderProduct: ActiveOrderProduct;

    onUpdateVariant(variantGroupProduct: VariantGroupProduct): void;
};

export function OrderProductVariantProduct({ orderProduct, onUpdateVariant }: Props) {
    const { menuProduct } = orderProduct;
    const { variantGroup } = menuProduct.product;
    const { format } = useCurrency();
    const selectedId = orderProduct.variantGroupProductId;
    const variantGroupProducts = variantGroup.variantGroupProducts.filter((item) => item.product);
    const variantProductPrice = useVariantProductPrice();

    const { element } = useXSelectable<VariantGroupProduct>({
        type: XSelectablesType.SINGLE,
        onSelect(item) {
            if (selectedId !== item.id) {
                onUpdateVariant(item);
            }
        },
        models: variantGroupProducts,
        modelIsChecked(model) {
            return model.id === selectedId;
        },
        modelFormatter(model) {
            const finalPrice = variantProductPrice.getFinalPrice({
                productId: model.productId,
                productPrice: model.price,
            });

            const targetPrice = finalPrice - menuProduct.price;
            const isZero = targetPrice === 0;

            return {
                key: model.id,
                title: <XText>{model.product.name}</XText>,
                contentRight: <XText>{!isZero && `${targetPrice < 0 ? '' : '+'}${format(targetPrice)}`}</XText>,
                value: model.id,
            };
        },
    });

    useEffect(() => {
        const variantGroupProduct = variantGroup.variantGroupProducts.find(
            (product) => product.productId === menuProduct.productId,
        );

        if (!orderProduct.variantGroupProductId && variantGroupProduct) {
            onUpdateVariant(variantGroupProduct);
        }
    }, []);

    return (
        <XCard className={'OrderProductVariantProduct'} gap={2} padding={2}>
            <XText type={XTextType.TITLE}>{variantGroup.name}</XText>
            {element}
        </XCard>
    );
}
